import { App, Button, Checkbox, Col, Form, Input, Modal, Row } from "antd";
import { FC, useEffect, useState } from "react";
import {
  useAddShippingAddress,
  useUpdateShippingAddress,
} from "services/address";
import { Address, CreateInput } from "src/lib/address-autocomplete";
import { IShippingAddress } from "types/address";
const InputThaiAddress = CreateInput();

interface IAddressModal {
  isOpen: boolean;
  onClose: () => void;
  data?: IShippingAddress;
}
const AddressModal: FC<IAddressModal> = ({ isOpen, data, onClose }) => {
  const [form] = Form.useForm();
  const { notification } = App.useApp();
  const { updateShippingAddressAsync, isPending: isPendingUpdate } =
    useUpdateShippingAddress();
  const { addShippingAddressAsync, isPending: isPendingAdd } =
    useAddShippingAddress();

  const [address, setAddress] = useState<Address>({
    district: "", // ตำบล tambol
    amphoe: "", // อำเภอ amphoe
    province: "", // จังหวัด changwat
    zipcode: "", // รหัสไปรษณีย์ postal code
  });

  const handleChange = (scope: string) => (value: string) => {
    setAddress((oldAddr: Address) => ({
      ...oldAddr,
      [scope]: value,
    }));
  };

  const handleSelect = (address: Address) => {
    form.setFieldsValue({
      province: address.province,
      district: address.amphoe,
      subdistrict: address.district,
      postCode: address.zipcode,
    });
    setAddress(address);
  };

  useEffect(() => {
    if (isOpen) {
      if (data) {
        form.setFieldsValue({
          fullName: data.fullName,
          type: data.type,
          building: data.building,
          road: data.road,
          moo: data.moo,
          address: data.address,
          phoneNumber: data.phoneNumber,
          province: data.province,
          district: data.district,
          subdistrict: data.subdistrict,
          postCode: data.postCode,
          isDefault: data.isDefault,
        });
      } else {
        console.log("reset");
        form.resetFields();
      }
    }
  }, [isOpen, data]);

  const handleOnSubmitForm = async () => {
    const formValue = form.getFieldsValue();
    // update address
    if (data) {
      await updateShippingAddressAsync({ id: data.id, ...formValue });
      notification.success({
        message: "แก้ไขที่อยู่สำเร็จ",
        // description: "",
        placement: "topRight",
      });
    } else {
      // add new address
      await addShippingAddressAsync(formValue);
      notification.success({
        message: "เพิ่มที่อยู่สำเร็จ",
        description: "",
        placement: "topRight",
      });
    }
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onClose={onClose}
      width={700}
      footer={() => {
        return (
          <div>
            {/* {data && (
              <div className="flex justify-center">
                <Button className="px-14" danger>
                  ลบที่อยู่นี้
                </Button>
              </div>
            )} */}
            <div className="justify-center flex gap-4 mt-8">
              <Button key="back" onClick={onClose} className="md:px-14">
                ยกเลิก
              </Button>
              <Button
                key="submit"
                type="primary"
                className="md:px-14"
                loading={isPendingUpdate || isPendingAdd}
                onClick={handleOnSubmitForm}
              >
                บันทึกข้อมูล
              </Button>
            </div>
          </div>
        );
      }}
    >
      <div className="text-center font-semibold">
        {data ? "แก้ไขที่อยู่" : "เพิ่มที่อยู่"}
      </div>
      <div className="px-4 md:px-20 py-5">
        <Form form={form} className="address-form">
          <Row gutter={[16, 16]}>
            <Col span={7}>ชื่อผู้รับสินค้า :</Col>
            <Col span={17}>
              <Form.Item name="fullName">
                <Input
                  className="gray-input-border"
                  placeholder="ชื่อผู้รับสินค้า"
                />
              </Form.Item>
            </Col>
            <Col span={7}>ชื่อ :</Col>
            <Col span={17}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="type">
                    <Input
                      className="gray-input-border"
                      placeholder="เช่น บ้านพ่อ โรงเรียน อื่นๆ"
                    />
                  </Form.Item>
                  <span className="text-gray-200 text-xs">
                    ตั้งชื่อที่อยู่ให้จำง่ายเวลาใช้ครั้งต่อไป
                  </span>
                </Col>
              </Row>
            </Col>
            <Col span={7}>ที่อยู่รับพัสดุ :</Col>
            <Col span={17}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="address">
                    <Input
                      className="gray-input-border"
                      placeholder="บ้านเลขที่"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="building">
                    <Input
                      className="gray-input-border"
                      placeholder="ชื่อสถานที่ / อาคาร"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={7} />
            <Col span={17}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="road">
                    <Input className="gray-input-border" placeholder="ถนน " />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="moo">
                    <Input className="gray-input-border" placeholder="หมู่" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={7} />
            <Col span={17}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="postCode">
                    <InputThaiAddress.Zipcode
                      value={address["zipcode"]}
                      onChange={handleChange("zipcode")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "รหัสไปรษณีย์",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="province">
                    <InputThaiAddress.Province
                      value={address["province"]}
                      onChange={handleChange("province")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "จังหวัด",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={7} />
            <Col span={17}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="district">
                    <InputThaiAddress.Amphoe
                      value={address["amphoe"]}
                      onChange={handleChange("amphoe")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "อำเภอ / เขต",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="subdistrict">
                    <InputThaiAddress.District
                      value={address["district"]}
                      onChange={handleChange("district")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "ตำบล",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={7}>เบอร์โทรติดต่อ :</Col>
            <Col span={17}>
              <Form.Item name="phoneNumber">
                <Input
                  className="gray-input-border"
                  placeholder="เบอร์โทรติดต่อ"
                />
              </Form.Item>
            </Col>
            <Col span={7} />
            <Col span={17}>
              <Form.Item name="isDefault" valuePropName="checked">
                <Checkbox>ตั้งค่าเป็นที่อยู่หลัก</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};
export default AddressModal;
